import { ImageUploadScadaIcon } from 'src/assets/icons/SCADA/assetsComponents/general/ImageUploadScadaIcon';
import { LiveTagLabelScadaIcon } from 'src/assets/icons/SCADA/assetsComponents/general/LiveTagLabelScadaIcon';
import { TextLabelScadaIcon } from 'src/assets/icons/SCADA/assetsComponents/general/TextLabelScadaIcon';
import { WaterLevelScadaIcon } from 'src/assets/icons/SCADA/assetsComponents/general/WaterLevelScadaIcon';
import { RotorScadaIcon } from 'src/assets/icons/SCADA/assetsComponents/RotorScadaIcon';
import { SpinningPumpScadaIcon } from 'src/assets/icons/SCADA/assetsComponents/SpinningPumpScadaIcon';
import { ValveScadaIcon } from 'src/assets/icons/SCADA/assetsComponents/ValveScadaIcon';
import { WaterTowerScadaIcon } from 'src/assets/icons/SCADA/assetsComponents/WaterTowerScadaIcon';
import { WetWellScadaIcon } from 'src/assets/icons/SCADA/assetsComponents/WetWellScadaIcon';
import { RectangleScadaIcon } from 'src/assets/icons/SCADA/shapes/RectangleScadaIcon';
import { SidebarGroupType } from './types';

import { ComponentType } from 'src/types/SCADA/componentsTypes';
import { SubmersiblePumpWithRotor } from 'src/assets/icons/SCADA/assetsComponents/SubmersiblePumpWithRotor';
import { RegularPumpWithRotor } from 'src/assets/icons/SCADA/assetsComponents/RegularPumpWithRotor';

export const SIDEBAR_COMPONENTS_CONTENT: SidebarGroupType[] = [
  {
    groupTitle: 'Assets',
    elements: [
      {
        id: 1,
        name: 'Submersible pump',
        icon: SubmersiblePumpWithRotor,
        type: ComponentType.SubmersiblePump,
        drawerType: 'asset',
        testId: 'submersible-pump',
      },
      {
        id: 2,
        name: 'Pump',
        icon: RegularPumpWithRotor,
        type: ComponentType.Pump,
        drawerType: 'asset',
        testId: 'regular-pump',
      },
      {
        id: 3,
        name: 'Submersible pump 2',
        icon: SpinningPumpScadaIcon,
        type: ComponentType.SpinningPump,
        drawerType: 'asset',
        testId: 'submersible-pump-2',
      },
      {
        id: 4,
        name: 'Well',
        icon: WetWellScadaIcon,
        type: ComponentType.Well,
        drawerType: 'asset',
        testId: 'well',
      },
      {
        id: 5,
        name: 'Tower',
        icon: WaterTowerScadaIcon,
        type: ComponentType.Tower,
        drawerType: 'asset',
        testId: 'tower',
      },
      {
        id: 6,
        name: 'Valve',
        icon: ValveScadaIcon,
        type: ComponentType.Valve,
        drawerType: 'asset',
        testId: 'valve',
      },
    ],
  },
  {
    groupTitle: 'General',
    elements: [
      {
        id: 1,
        name: 'Text label',
        icon: TextLabelScadaIcon,
        type: ComponentType.TextLabel,
        drawerType: 'textLabel',
        testId: 'text-label',
      },
      {
        id: 2,
        name: 'Live data label',
        icon: LiveTagLabelScadaIcon,
        type: ComponentType.LiveTagLabel,
        drawerType: 'liveTagLabel',
        testId: 'live-tag-label',
      },
      {
        id: 3,
        name: 'Image upload',
        icon: ImageUploadScadaIcon,
        type: ComponentType.ImageUpload,
        drawerType: 'imageUpload',
        testId: 'image-upload',
      },
      {
        id: 4,
        name: 'Rotor',
        icon: RotorScadaIcon,
        type: ComponentType.Rotor,
        drawerType: 'asset',
        testId: 'rotor',
      },
      {
        id: 5,
        name: 'Water Level',
        icon: WaterLevelScadaIcon,
        type: ComponentType.WaterLevelShape,
        drawerType: 'tag',
        testId: 'water-level',
      },
    ],
  },
  {
    groupTitle: 'Shapes',
    elements: [
      {
        id: 1,
        name: 'Rectangle',
        icon: RectangleScadaIcon,
        type: ComponentType.Rectangle,
        drawerType: 'rectangle',
        testId: 'rectangle',
      },
    ],
  },
];
